import { render, staticRenderFns } from "./template-permissions.vue?vue&type=template&id=00d51cd6&scoped=true"
import script from "./template-permissions.vue?vue&type=script&lang=js"
export * from "./template-permissions.vue?vue&type=script&lang=js"
import style0 from "./template-permissions.vue?vue&type=style&index=0&id=00d51cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d51cd6",
  null
  
)

export default component.exports